var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_30304)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 81,
    height: 81,
    rx: 40.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9623 62.6562H39.0373C31.9498 62.6562 26.3811 58.1937 24.8436 51.2749L24.0749 47.7874C23.5499 45.3874 24.9186 42.7999 27.1873 41.8812L40.1811 36.6687C42.3186 35.825 44.6811 35.825 46.8186 36.6687L59.8123 41.8812C62.0998 42.7999 63.4685 45.3874 62.9248 47.7874L62.1561 51.2749C60.6186 58.1937 55.0498 62.6562 47.9623 62.6562ZM43.4998 38.8437C42.7311 38.8437 41.9623 38.9937 41.2123 39.2749L28.2186 44.4874C27.2248 44.8812 26.5686 46.1374 26.7936 47.1687L27.5623 50.6562C28.8186 56.3187 33.206 59.8249 39.0185 59.8249H47.9436C53.7561 59.8249 58.1436 56.3187 59.3998 50.6562L60.1686 47.1687C60.3936 46.1374 59.7373 44.8812 58.7436 44.4874L45.7499 39.2749C45.0373 38.9937 44.2686 38.8437 43.4998 38.8437Z",
    fill: "url(#paint0_linear_19_30304)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 62.6562C42.7312 62.6562 42.0938 62.0187 42.0938 61.25V38.75C42.0938 37.9812 42.7312 37.3438 43.5 37.3438C44.2687 37.3438 44.9062 37.9812 44.9062 38.75V61.25C44.9062 62.0187 44.2687 62.6562 43.5 62.6562Z",
    fill: "url(#paint1_linear_19_30304)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6252 43.5312C56.4565 43.5312 56.269 43.4938 56.1002 43.4375L45.7689 39.2938C44.3064 38.7125 42.694 38.7125 41.2127 39.2938L30.8814 43.4375C30.4502 43.6063 29.9627 43.55 29.569 43.2875C29.1752 43.025 28.9502 42.5937 28.9502 42.125V35C28.9502 31.1188 32.1002 27.9688 35.9814 27.9688H50.9814C54.8627 27.9688 58.0127 31.1188 58.0127 35V42.125C58.0127 42.5937 57.7877 43.025 57.394 43.2875C57.169 43.4563 56.9065 43.5312 56.6252 43.5312ZM43.5002 36.0312C44.6252 36.0312 45.7502 36.2375 46.8189 36.6688L55.219 40.0438V35C55.219 32.675 53.3252 30.7813 51.0002 30.7813H36.0002C33.6752 30.7813 31.7815 32.675 31.7815 35V40.0438L40.1815 36.6688C41.2502 36.2563 42.3752 36.0312 43.5002 36.0312Z",
    fill: "url(#paint2_linear_19_30304)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1875 30.7812H38.8125C38.0437 30.7812 37.4062 30.1438 37.4062 29.375V25.625C37.4062 23.825 38.8875 22.3438 40.6875 22.3438H46.3125C48.1125 22.3438 49.5938 23.825 49.5938 25.625V29.375C49.5938 30.1438 48.9563 30.7812 48.1875 30.7812ZM40.2188 27.9688H46.7812V25.625C46.7812 25.3625 46.575 25.1562 46.3125 25.1562H40.6875C40.425 25.1562 40.2188 25.3625 40.2188 25.625V27.9688Z",
    fill: "url(#paint3_linear_19_30304)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_30304",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_30304"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_30304",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_30304",
    x1: 43.5033,
    y1: 36.0359,
    x2: 43.5033,
    y2: 62.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_30304",
    x1: 43.5,
    y1: 37.3438,
    x2: 43.5,
    y2: 62.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19_30304",
    x1: 43.4814,
    y1: 27.9688,
    x2: 43.4814,
    y2: 43.5334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19_30304",
    x1: 43.5,
    y1: 22.3438,
    x2: 43.5,
    y2: 30.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingicon);
export default __webpack_public_path__ + "static/media/shippingicon.80849f6e51e26aee5ffaf7607ea843b2.svg";
export { ForwardRef as ReactComponent };